<template>
	<div class="clients-manager">
		<vx-card class="my-8">
			<div class="vx-row justify-between">
				<div class="perPage w-1/3 sm:w-1/2 vx-col">
					<v-select
						v-model="select1"
						:searchable="false"
						:options="[10,20,50]"
						class="selectExample clientsm-pages-amount w-full"
					/>
				</div>
				<div class="vx-col w-2/3 sm:w-1/3 lg:w-1/5">
					<vs-input
						v-model="searchName"
						@input="filterTable"
						:placeholder="$t('searchByName') + '...'"
						class="w-full"
					></vs-input>
				</div>
			</div>

			<div class="tab-text ">
				<vs-table :max-items="select1" pagination :data="works">
					<template slot="thead">
						<vs-th
							v-for="fil in field" :style="'width:' +fil.width"
							:class="{
								'justify-center': fil.align && fil.align === 'center',
								'text-center': fil.align && fil.align === 'center'
							}"
						>{{ fil.title }}</vs-th>
					</template>

					<template slot-scope="{ data }">

						<vs-tr :key="indextr" v-for="(tr, indextr) in data">
							<template v-for="fil in field">
								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
									   v-if="fil.field === 'name'">
									<router-link :to="'clientM/' + tr.id">
										{{ getClientName(tr.first_name, tr.last_name) }}
									</router-link>
								</vs-td>

								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
									   v-else-if="fil.field === 'client.username'">
									<!--											<router-link :to="'client/' + deepFind(tr, 'client.id')">-->
									<router-link to="/">
										{{ deepFind(tr, fil.field) }}
									</router-link>
								</vs-td>

								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
									   v-else-if="fil.field === 'author.username'">
									<router-link v-if="tr[fil.field]" :to="'client/' + deepFind(tr, 'author.id')">
										{{ deepFind(tr, fil.field) }}
									</router-link>
								</vs-td>

								<vs-td
									v-else-if="fil.field === 'chat_messages_count'"
									:class="{'text-center': fil.align && fil.align === 'center'}"
									>
										<div class="flex justify-center">
											<span
												class="counter"
												:class="{ warn: tr.has_new_message }"
											>
												{{ tr.chat_messages_count }}
											</span>
										</div>
								</vs-td>

								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
									   v-else-if="fil.field === 'subject'">
									{{
										$getDeep(tr.subject, subjects)
									}}
								</vs-td>
								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
									   v-else-if="fil.field === 'work_type'">
									{{
										$getDeep(tr.work_type, works)
									}}
								</vs-td>
								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
									   v-else-if="fil.field === 'quality_level'">
									{{
										$getDeep(tr.quality_level, levels)
									}}
								</vs-td>
								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
									   v-else-if="fil.field === 'gender'">
									{{
										$getDeep(tr.gender, genders)
									}}
								</vs-td>
								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
									   v-else-if="fil.field === 'country'">
									{{
										$getDeep(tr.country, countries)
									}}
								</vs-td>
								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
									   v-else-if="fil.field === 'task'">
<!--									<span -->
<!--										v-if="tr[fil.field]"-->
<!--										@click="getTask(tr)"-->
<!--										class="task" -->
<!--									>{{ tr[fil.field].date_time | moment('DD.MM.YYYY') }}</span>-->
<!--									<span -->
<!--										v-else-->
<!--										@click="idOrder = tr.id;activePrompt = true" -->
<!--										class="task" -->
<!--									>+</span>-->

									<span
										v-if="tr[fil.field]"
										@click="getTask(tr)"
										class="task cursor-pointer"
									>{{ tr[fil.field].date_time | moment('DD.MM.YYYY') }}</span>

									<span
										v-else
										@click="createTask(tr)"
										class="task cursor-pointer"
									>+</span>
								</vs-td>
								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
									   v-else-if="fil.field === 'price'">
									{{ tr[fil.field] }}
								</vs-td>
								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
									   v-else-if="fil.field === 'is_enabled_for_junior'">
									{{ tr[fil.field] ? $t('yes') : $t('no') }}
								</vs-td>
								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
									   v-else-if="fil.field === 'actions'">
									<div class="flex justify-center"
										 @click="$store.dispatch('getMessages',{userId: tr.id})">
										<vs-button
											size="small"
											color="#626262"
											type="flat"
											icon-pack="feather"
											icon="edit"
										>
											<feather-icon icon="MessageSquareIcon"></feather-icon>
										</vs-button>
									</div>
								</vs-td>
								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
									   v-else-if="tr[fil.field] || tr[fil.field] === 0">
									{{ tr[fil.field] }}
								</vs-td>
								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-else>
									...
								</vs-td>
							</template>

						</vs-tr>
					</template>
				</vs-table>
			</div>
		</vx-card>
		<AddOrderTask
			:active.sync="addTaskPopup"
			:order="selectedOrder"
			mode="client"
		/>
		<ViewOrderTask
			:active.sync="viewTaskPopup"
			:order="selectedOrder"
			mode="client"
		/>
	</div>
</template>

<script>
import AddOrderTask from "@/components/dialogs/AddOrderTask";
import ViewOrderTask from "@/components/dialogs/ViewOrderTask";
import vSelect from 'vue-select'
import datepicker from 'vuejs-datepicker'
import debounce from 'debounce'
import notifier from "@/mixins/notifier";

export default {
	name: "typeWorks",
	mixins: [notifier],
	components: {
		AddOrderTask,
		ViewOrderTask,
		'v-select': vSelect,
		datepicker
	},
	data() {
		return {
			about: '',
			date: '',
			searchName: '',
			searchEmail: '',
			searchPhone: '',

			select1: 10,
			nameRu: '',
			nameDe: '',
			price: '',
			juniorIs: false,

			addTaskPopup: false,
			viewTaskPopup: false,
			selectedOrder: null,
			subjects: [],
			works: [],
			countries: [],
			genders: [],
			editModel: {},
			task: {},
		};
	},
	methods: {
		getClientName(firstName, lastName) {
			const fullName = [firstName, lastName].join(" ");
			return fullName !== " " ? fullName : "---";
		},
		filterTable: debounce(function (e) {
			let options = '?';
			if (this.searchName.length > 0) options += 'filter[name]=' + this.searchName + '&'
			if (this.searchEmail.length > 0) options += 'filter[email]=' + this.searchEmail + '&'
			if (this.searchPhone.length > 0) options += 'filter[phone]=' + this.searchPhone
			this.getWorks(options);
		}, 500),
		async removeTask() {
			try {

				await this.$http.post("/manager/task/delete/" + this.editModel.id);

				this.notifySuccess(this.$t('deletedSuccessfully'));
				this.editModel = {};
				this.getWorks();

			} catch (e) {
				this.notifyError(e.message);
			}
		},
		createTask(order) {
			this.selectedOrder = order;
			this.addTaskPopup = true;
		},
		async getTask(order) {
			this.selectedOrder = order;
			this.viewTaskPopup = true;
		},
		deepFind(obj, path) {
			if (!path) return "";
			let paths = path.split("."),
				current = obj,
				i;

			for (i = 0; i < paths.length; ++i) {
				if (current[paths[i]] === undefined) {
					return undefined;
				} else {
					current = current[paths[i]];
				}
			}
			return current;
		},
		async getWorks(options) {
			try {
				let url = options ? "/manager/client" + options : "/manager/client";
				const res = (await this.$http.get(url)).data.data;
				this.works = res || [];

			} catch (e) {
				this.notifyError(e.message);
			}
		},
	},
	created() {

		this.field = [
			{
				field: "name",
				title: this.$t('personName'),
				align: 'center',
				width: '12.5%'
			},
			{
				field: "tickets_count",
				title: this.$t('totalTicketsAmount'),
				align: 'center',
				width: '12.5%'
			},
			{
				field: "tickets_active_count",
				title:this.$t('activatedTickets'),
				align: 'center',
				width: '12.5%'
			},
			{
				field: "gender",
				title: this.$t('sex'),
				align: 'center',
				width: '12.5%'
			},
			{
				field: "country",
				title: this.$t('country'),
				align: 'center',
				width: '12.5%'
			},
			{
				field: "task",
				title: this.$t('task'),
				align: 'center',
				width: '12.5%'
			},
			{
				field: "chat_messages_count",
				title: "",
				align: 'center',
				width: '12.5%'
			},
			{
				field: "actions",
				title: this.$t('actions'),
				align: 'center',
				width: '12.5%'
			},
		];
	},
	async mounted() {
		this.getWorks();

		this.genders = (await this.$http.get("/settings/get-genders")).data.data;
		this.countries = (await this.$http.get("/settings/get-countries")).data.data;
	},
};
</script>

<style lang="scss">
@import "../../assets/scss/vuexy/variables";
@import "../../assets/scss/vuexy/functions";

.clients-manager {
	.buttons {
		justify-content: flex-end;
	}

	.button-task {
		border-radius: 22px;
		padding: 0.25rem 0.7rem !important;
	}

	.vs--single.vs--open .vs__selected {
		position: initial;
	}

	th.text-center {
		& > .vs-table-text {
			text-align: center;
		}
	}

	.fade-enter-active,
	.fade-leave-active {
		transition: opacity 0.5s;
	}

	.perPage {
		max-width: 110px;
		display: flex;
		align-items: flex-start;

		.vs__dropdown-toggle {
			border-radius: 100px;
		}

		.vs__clear {
			display: none;
		}

		.v-select__selection {
			width: 100%;
			justify-content: center;
		}

		.vs__selected-options {
			flex-wrap: nowrap;
		}
	}

	.inputInTable {
		border: 0;
		resize: none;
	}

	.fade-enter, .fade-leave-to
	{
		opacity: 0;
	}

	.buttons {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		@media screen and (max-width: 375px) {
			button {
				margin: 5px 0;
			}
		}
	}

	.justify-center .vs-table-text {
		justify-content: center;
	}

	.vs-checkbox-default {
		flex-shrink: 0;
	}

	.vs-tabs--content {
		padding: 0;
		margin-top: 10px;
	}

	.vs-con-table .vs-con-tbody {
		border: 0;
		background-color: transparent;
	}

	.vs-table {
		margin-top: 10px;

		tr {
			border-top: 1px solid #cfcfcf;

			&:last-child {
				border-bottom: 1px solid #cfcfcf;
			}
		}
	}

	.con-vs-tabs .con-slot-tabs {
		overflow: visible;
	}

	.task {
		background-color: #3ac47d;
		border-radius: 10px;
		padding: 4px 10px;
		color: white;
	}

	.counter {
		display: inline-block;
		padding: 5px;
		border-radius: 100%;
		font-weight: 600;
		width: 20px;
		height: 20px;
		font-size: 0.7rem;
		border: 1px solid #cfcfcf;
		display: flex;
		align-items: center;
		justify-content: center;
		line-height: 1;

		&.warn {
			background-color: #f0ad4e;
			color: white;
			border-color: #f0ad4e;
		}
	}

	.filter {
		border-bottom: 1px solid #e5e5e5;
		padding-bottom: 1rem;
		padding-top: 0.5rem;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;

		.date {
			display: flex;
			align-items: center;
		}

		.vx-input-group .vx-input-group-default .vs-input {
			width: 150px;
		}

		.vx-input-group {
			margin-right: 20px;
		}

		.search .vs-icon {
			height: 100%;
			width: 35px;
			background: $primary;
			position: absolute;
			top: 0;
			right: 0;
			color: white !important;
			display: flex;
			align-items: center;
			justify-content: center;
			border-top-right-radius: 4px;
			border-bottom-right-radius: 4px;
			font-size: 22px;
		}

		.search .vs-con-input-label {
			width: 270px;
		}
	}
}

.con-exemple-prompt {
	.append-text {
		height: 2.7rem;
	}

	.vs-button {
		border-left: 0;
	}

	.vx-input-group-append {
		align-items: flex-end;
	}

	.vs-input {
		width: 100%;

		textarea {
			resize: none;
		}
	}
}

.viewTask {
	.vs-popup--title h3 {
		color: $primary;
	}

	.vs-popup--content {
		padding: 0;
	}

	table {
		width: 100%;

		td {
			padding-bottom: 4px;
		}
	}

	.body {
		padding: 1rem;

		table {
			margin-left: -2px;
		}

		p {
			padding-top: 10px;
			font-size: rem(14px);
		}
	}

	.footer {
		border-top: 1px solid rgba(0, 0, 0, 0.05);
		padding: 0.5rem 1rem;
		display: flex;
		justify-content: flex-end;

		button {
			margin-left: 10px;
		}
	}
}
</style>
